@let contactInfo = contactInfo$ | async;
@let useMobileLayout = useMobileLayout$ | async;
@let contactCardPhotoUrl = contactCardPhotoUrl$ | async;

<red-contact-card-header></red-contact-card-header>
<div class="tw:b-0 tw:l-0 tw:px-4 tw:pt-4 tw:pb-2 tw:text-xs">
  <div class="tw:border-b tw:border-gray-200 tw:uppercase tw:opacity-90">Contact Me</div>
  <div class="tw:py-1">
    <ion-button size="small" fill="clear" color="light" (click)="email($event)">
      <ion-icon name="mail-outline" slot="start"></ion-icon>
      {{ contactInfo?.email }}
    </ion-button>
  </div>
  <div
    class="tw:grid"
    [ngClass]="{
      'tw:grid-cols-3': !useMobileLayout,
      'tw:grid-cols-2': useMobileLayout
    }"
  >
    <ion-button
      class="tw:justify-self-start"
      size="small"
      fill="clear"
      color="light"
      href="tel:{{ contactInfo?.phone ?? '' }}"
      (click)="stopPropagation($event)"
    >
      <ion-icon src="/assets/svg/phone.svg" slot="start"></ion-icon>
      {{ contactInfo?.phone | maskito: phoneMask }}
    </ion-button>
    <ion-button
      [ngClass]="{
        'tw:justify-self-center': !useMobileLayout,
        'tw:justify-self-end': useMobileLayout
      }"
      size="small"
      fill="clear"
      color="light"
      href="sms:{{ contactInfo?.phone ?? '' }}"
      (click)="stopPropagation($event)"
    >
      <ion-icon src="/assets/svg/sms.svg" slot="end"></ion-icon>
      SMS
    </ion-button>
    @if (useMobileLayout) {
      <ion-button class="tw:justify-self-start" size="small" fill="clear" color="light" (click)="addToContacts($event)">
        <ion-icon src="/assets/svg/add-contact.svg" slot="start"></ion-icon>
        Add to Contacts
      </ion-button>
    }
    <ion-button
      class="tw:justify-self-end"
      routerLink="{{ shareContactInfoUrl }}"
      size="small"
      fill="clear"
      color="light"
    >
      <ion-icon name="qr-code-outline" slot="end"></ion-icon>
      Share Contact
    </ion-button>
  </div>
  @if (contactCardPhotoUrl) {
    <div class="tw:relative tw:mx-1 tw:h-32">
      <img
        priority
        alt="Contact Image"
        class="tw:object-contain tw:object-left"
        ngSrc="{{ contactCardPhotoUrl }}"
        fill
      />
    </div>
  }
</div>
